import React from "react";
import { useTheme } from "styled-components";
import {
  Container,
  Emoji,
  IconContainer,
  IconTitleWrapper,
  Title,
} from "../styled";
import Icon, { getIconType } from "../../../../../components/ui/icon/Icon";
import EditableText from "../inline-edit/EditableText";
import { shadeColor } from "../../../../../helpers/shade-color";
import TextEdit from "../TextEdit";

function CustomIcon({ data, isEditable, isTemplate }) {
  const theme = useTheme();

  const {
    borderRadius,
    accentColor,
    textColor,
    displayElements,
    icon,
    colorMute,
  } = data;

  const accent = accentColor[theme.name];
  const text = textColor[theme.name];
  const bgMuted = `${accent.slice(0, 7)}4d`;
  const textMuted = shadeColor(accent, theme.name === "dark" ? 40 : -40);

  const iconType = getIconType(icon);

  return (
    <Container bgClr={colorMute ? bgMuted : accent} radius={borderRadius}>
      <IconTitleWrapper
        align={displayElements.includes("title") ? "center" : "flex-start"}
      >
        {displayElements.includes("icon") && (
          <>
            {icon?.native ? (
              <Emoji>{icon.native}</Emoji>
            ) : (
              <IconContainer color={colorMute ? textMuted : text}>
                {iconType === "app" ? (
                  <img src={icon} alt="img" height="24px" />
                ) : (
                  <Icon icon={icon} size="24px" />
                )}
              </IconContainer>
            )}
          </>
        )}
        {displayElements.includes("title") ? (
          <Title clr={colorMute ? textMuted : text}>
            <EditableText data={data} isEditable={isEditable} field="title" />
          </Title>
        ) : (
          <>
            {displayElements.includes("text") && (
              <TextEdit
                data={data}
                textColor={colorMute ? textMuted : text}
                isEditable={isEditable}
                isTemplate={isTemplate}
              />
            )}
          </>
        )}
      </IconTitleWrapper>
      {displayElements.includes("text") &&
        displayElements.includes("title") && (
          <TextEdit
            data={data}
            textColor={colorMute ? textMuted : text}
            isEditable={isEditable}
            isTemplate={isTemplate}
          />
        )}
    </Container>
  );
}

export default CustomIcon;
